import Vue from 'vue'
import App from './App.vue'
import router from './router'
import translationService from '@/services/translationService'
import translationMixin from '@/mixins/translationMixin'

Vue.config.productionTip = false

// Make translation service globally available
Vue.prototype.$translationService = translationService

// Make translation mixin globally available to all components
Vue.mixin(translationMixin)

// Initialize the application after translation service is ready
async function initializeApp() {
  try {
    // Wait for translation service to initialize with saved language preference
    await translationService.waitForInitialization()
    
    // Create and mount the Vue application
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
    
  } catch (error) {
    console.error('Failed to initialize translation system:', error)
    
    // Fallback: mount app anyway to prevent complete failure
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
}

// Start the application
initializeApp()
